import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DeleteIcon, DlIcon, ExpandIcon } from '../../../../components/Icons';
import MediaToolbarButton from './Button';
import onDownload from '../utils/onDownload';
import './style.css';

var MediaToolbar =
/*#__PURE__*/
function (_Component) {
  _inherits(MediaToolbar, _Component);

  function MediaToolbar() {
    _classCallCheck(this, MediaToolbar);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediaToolbar).apply(this, arguments));
  }

  _createClass(MediaToolbar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          blockKey = _this$props.blockKey,
          toggleLightbox = _this$props.toggleLightbox,
          enableLightbox = _this$props.enableLightbox,
          allowDownload = _this$props.allowDownload,
          readOnly = _this$props.readOnly,
          onRemove = _this$props.onRemove,
          error = _this$props.error;
      return React.createElement("div", {
        className: "media-toolbar position-absolute flexbox flexbox-centered",
        style: {
          right: 10,
          top: 10
        }
      }, !readOnly && React.createElement(MediaToolbarButton, {
        id: "delete",
        actionText: "Delete",
        actionColor: "red",
        onClick: function onClick(event) {
          onRemove();
        }
      }, React.createElement(DeleteIcon, {
        size: 16
      })), allowDownload && !error && React.createElement(MediaToolbarButton, {
        id: "download",
        actionText: "Download",
        actionColor: "primary-dark",
        onClick: function onClick(event) {
          onDownload(event, {
            url: url
          });
        }
      }, React.createElement(DlIcon, {
        size: 16
      })), enableLightbox && !error && React.createElement(MediaToolbarButton, {
        id: "expand",
        actionText: "Expand",
        actionColor: "primary-dark",
        onClick: function onClick(event) {
          event.preventDefault();
          toggleLightbox({
            blockKey: blockKey
          });
        }
      }, React.createElement(ExpandIcon, {
        size: 16
      })));
    }
  }]);

  return MediaToolbar;
}(Component);

_defineProperty(MediaToolbar, "propTypes", {
  blockKey: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  toggleLightbox: PropTypes.func.isRequired,
  enableLightbox: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  allowDownload: PropTypes.bool,
  error: PropTypes.bool
});

export default MediaToolbar;